// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  display: flex;
  width: 100%;
  height: 84px;
  z-index: 1;
  background: var(--header-bg);
}
.header__container {
  width: 100%;
  height: 84px;
  display: flex;
  gap: 56px;
  align-items: center;
}
.header__container-item:nth-child(1) {
  width: 85px;
}
.header__container-item:nth-child(1) img {
  width: 100%;
}
.header__container-item:nth-child(2) {
  width: 60px;
}
.header__container-item:nth-child(2) a {
  height: 100%;
  display: block;
  text-decoration: unset;
}
.header__container-item:nth-child(2) a span {
  display: block;
  font-weight: 700;
  font-size: 36px;
  line-height: 42px;
  color: #ff0009;
}
.header__container-item:nth-child(3) .user-container {
  position: relative;
  transform: translateY(0%);
  transition-delay: 0s, 0s, 0.3s;
  padding: 10px;
  height: 48px;
  background: #eaf6ff;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header__container-item:nth-child(3) .user-container svg {
  width: 28px;
  height: 28px;
}
.header__container-item:nth-child(3) .user-container span:nth-child(1) {
  display: block;
  width: 28px;
  height: 28px;
}
.header__container-item:nth-child(3) .user-container span:nth-child(1) svg {
  width: 28px;
  height: 28px;
}
.header__container-item:nth-child(3) .user-container span:nth-child(2) {
  font-family: "Roboto", serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #999999;
}
.header__container-item:nth-child(3) .dropdown-menu {
  display: none;
  position: absolute;
  background: #eaf6ff;
  width: 181px;
  min-height: 50px;
  padding: 16px;
  transform: translateY(-10px);
  border: unset;
}
.header__container-item:nth-child(3) .dropdown-menu__title {
  display: none;
}
.header__container-item:nth-child(3) .dropdown-menu__item {
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.header__container-item:nth-child(3) .dropdown-menu__button:nth-child(2) {
  margin-top: 10px;
}
.header__container-item:nth-child(3) .dropdown-menu__button button {
  width: 100%;
  background: #ffffff;
  color: red;
  border-radius: 8px;
  padding: 5px 10px;
  border: 1px solid red;
  white-space: nowrap;
}
.header__container-item:nth-child(3) .dropdown-menu__button .button-red {
  background: red;
  color: #ffffff;
}
.header__container-item:nth-child(3) .dropdown-active {
  display: block;
}
.header__mobile-menu {
  background: unset;
  display: none;
}
.header__mobile-menu svg {
  stroke: var(--text-color);
}
.header__logo {
  width: 100px;
  display: block;
}
.header__logo img {
  width: 100%;
}
.header__list {
  display: flex;
  gap: 20px;
}
.header__list-item {
  padding: 8px;
  color: var(--text-color);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}
.header__list-item:hover {
  color: var(--text-color);
}
.header__list-item--active {
  border-bottom: 2px solid #ff0009;
}
.header__buttons {
  display: flex;
  gap: 34px;
  margin-left: auto;
}
.header__button {
  padding: 10px 28px;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  border: 1px solid;
  border-radius: 8px;
  color: var(--text-color);
}
.header__button:hover {
  color: var(--text-color);
}
.header__button--outline {
  background: unset;
  border-color: var(--text-color);
}
.header__button--primary {
  background-color: #ff0009;
  border-color: #ff0009;
  color: #ffffff;
}
.header__button--primary:hover {
  color: #ffffff;
}

@media only screen and (max-width: 1199px) {
  .header__list {
    display: none;
  }
  .header__mobile-menu {
    display: block;
  }
  .header__container {
    gap: 12px;
  }
}
@media only screen and (max-width: 992px) {
  .header .header-container-item:nth-child(1) {
    width: auto;
  }
  .header .header-container-item:nth-child(2) {
    width: 40px;
  }
  .header .header-container-item:nth-child(2) a span {
    font-size: 24px;
    line-height: 28px;
  }
  .header .header-container-item:nth-child(3) .user-container {
    width: unset;
  }
  .header .header-container-item:nth-child(3) .user-container span:nth-child(2) {
    display: none;
  }
  .header .header-container-item:nth-child(3) .dropdown-menu {
    transform: translateX(-133px);
    border-radius: 8px;
  }
  .header .header-container-item:nth-child(3) .dropdown-menu__title {
    display: unset;
    text-align: center;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: #999999;
  }
}
@media only screen and (max-width: 575px) {
  .header__buttons {
    gap: 8px;
  }
  .header__button {
    padding: 8px 10px;
  }
}
@media only screen and (max-width: 374px) {
  .header__button {
    flex-shrink: 0;
    padding: 4px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/header/Header.scss","webpack://./src/components/header/Header.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,4BAAA;ACCF;ADCE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;ACCJ;ADCI;EACE,WAAA;ACCN;ADCM;EACE,WAAA;ACCR;ADGI;EACE,WAAA;ACDN;ADGM;EACE,YAAA;EACA,cAAA;EACA,sBAAA;ACDR;ADGQ;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDV;ADOM;EACE,kBAAA;EACA,yBAAA;EACA,8BAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EAEA,aAAA;EACA,8BAAA;EACA,mBAAA;ACNR;ADQQ;EACE,WAAA;EACA,YAAA;ACNV;ADSQ;EACE,cAAA;EACA,WAAA;EACA,YAAA;ACPV;ADSU;EACE,WAAA;EACA,YAAA;ACPZ;ADWQ;EACE,4BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACTV;ADaM;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,4BAAA;EACA,aAAA;ACXR;ADaQ;EACE,aAAA;ACXV;ADcQ;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;ACZV;ADgBU;EACE,gBAAA;ACdZ;ADiBU;EACE,WAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;ACfZ;ADkBU;EACE,eAAA;EACA,cAAA;AChBZ;ADqBM;EACE,cAAA;ACnBR;ADwBE;EACE,iBAAA;EACA,aAAA;ACtBJ;ADwBI;EACE,yBAAA;ACtBN;AD0BE;EACE,YAAA;EACA,cAAA;ACxBJ;AD0BI;EACE,WAAA;ACxBN;AD4BE;EACE,aAAA;EACA,SAAA;AC1BJ;AD4BI;EACE,YAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AC1BN;AD4BM;EACE,wBAAA;AC1BR;AD6BM;EACE,gCAAA;AC3BR;ADgCE;EACE,aAAA;EACA,SAAA;EACA,iBAAA;AC9BJ;ADiCE;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,wBAAA;AC/BJ;ADiCI;EACE,wBAAA;AC/BN;ADkCI;EACE,iBAAA;EACA,+BAAA;AChCN;ADmCI;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;ACjCN;ADmCM;EACE,cAAA;ACjCR;;ADuCA;EAEI;IACE,aAAA;ECrCJ;EDwCE;IACE,cAAA;ECtCJ;EDyCE;IACE,SAAA;ECvCJ;AACF;AD2CA;EAGM;IAEE,WAAA;EC5CN;ED+CI;IACE,WAAA;EC7CN;EDgDQ;IACE,eAAA;IACA,iBAAA;EC9CV;EDoDM;IACE,YAAA;EClDR;EDoDQ;IACE,aAAA;EClDV;EDsDM;IACE,6BAAA;IACA,kBAAA;ECpDR;EDsDQ;IACE,cAAA;IACA,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,cAAA;ECpDV;AACF;AD2DA;EAEI;IACE,QAAA;EC1DJ;ED6DE;IACE,iBAAA;EC3DJ;AACF;AD+DA;EAEI;IACE,cAAA;IACA,YAAA;EC9DJ;AACF","sourcesContent":[".header {\n  display: flex;\n  width: 100%;\n  height: 84px;\n  z-index: 1;\n  background: var(--header-bg);\n\n  &__container {\n    width: 100%;\n    height: 84px;\n    display: flex;\n    gap: 56px;\n    align-items: center;\n\n    &-item:nth-child(1) {\n      width: 85px;\n\n      img {\n        width: 100%;\n      }\n    }\n\n    &-item:nth-child(2) {\n      width: 60px;\n\n      a {\n        height: 100%;\n        display: block;\n        text-decoration: unset;\n\n        span {\n          display: block;\n          font-weight: 700;\n          font-size: 36px;\n          line-height: 42px;\n          color: #ff0009;\n        }\n      }\n    }\n\n    &-item:nth-child(3) {\n      .user-container {\n        position: relative;\n        transform: translateY(0%);\n        transition-delay: 0s, 0s, 0.3s;\n        padding: 10px;\n        height: 48px;\n        background: #eaf6ff;\n        border-radius: 8px;\n\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n\n        svg {\n          width: 28px;\n          height: 28px;\n        }\n\n        span:nth-child(1) {\n          display: block;\n          width: 28px;\n          height: 28px;\n\n          svg {\n            width: 28px;\n            height: 28px;\n          }\n        }\n\n        span:nth-child(2) {\n          font-family: 'Roboto', serif;\n          font-weight: 400;\n          font-size: 16px;\n          line-height: 19px;\n          color: #999999;\n        }\n      }\n\n      .dropdown-menu {\n        display: none;\n        position: absolute;\n        background: #eaf6ff;\n        width: 181px;\n        min-height: 50px;\n        padding: 16px;\n        transform: translateY(-10px);\n        border: unset;\n\n        &__title {\n          display: none;\n        }\n\n        &__item {\n          padding-top: 10px;\n          display: flex;\n          flex-direction: column;\n          justify-content: space-between;\n        }\n\n        &__button {\n          &:nth-child(2) {\n            margin-top: 10px;\n          }\n\n          button {\n            width: 100%;\n            background: #ffffff;\n            color: red;\n            border-radius: 8px;\n            padding: 5px 10px;\n            border: 1px solid red;\n            white-space: nowrap;\n          }\n\n          .button-red {\n            background: red;\n            color: #ffffff;\n          }\n        }\n      }\n\n      .dropdown-active {\n        display: block;\n      }\n    }\n  }\n\n  &__mobile-menu {\n    background: unset;\n    display: none;\n\n    svg {\n      stroke: var(--text-color);\n    }\n  }\n\n  &__logo {\n    width: 100px;\n    display: block;\n\n    img {\n      width: 100%;\n    }\n  }\n\n  &__list {\n    display: flex;\n    gap: 20px;\n\n    &-item {\n      padding: 8px;\n      color: var(--text-color);\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 20px;\n\n      &:hover {\n        color: var(--text-color);\n      }\n\n      &--active {\n        border-bottom: 2px solid #ff0009;\n      }\n    }\n  }\n\n  &__buttons {\n    display: flex;\n    gap: 34px;\n    margin-left: auto;\n  }\n\n  &__button {\n    padding: 10px 28px;\n    text-align: center;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n    border: 1px solid;\n    border-radius: 8px;\n    color: var(--text-color);\n\n    &:hover {\n      color: var(--text-color);\n    }\n\n    &--outline {\n      background: unset;\n      border-color: var(--text-color);\n    }\n\n    &--primary {\n      background-color: #ff0009;\n      border-color: #ff0009;\n      color: #ffffff;\n\n      &:hover {\n        color: #ffffff;\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 1199px) {\n  .header {\n    &__list {\n      display: none;\n    }\n\n    &__mobile-menu {\n      display: block;\n    }\n\n    &__container {\n      gap: 12px;\n    }\n  }\n}\n\n@media only screen and (max-width: 992px) {\n  .header {\n    .header-container {\n      &-item:nth-child(1) {\n        // width: 71px;\n        width: auto;\n      }\n\n      &-item:nth-child(2) {\n        width: 40px;\n\n        a {\n          span {\n            font-size: 24px;\n            line-height: 28px;\n          }\n        }\n      }\n\n      &-item:nth-child(3) {\n        .user-container {\n          width: unset;\n\n          span:nth-child(2) {\n            display: none;\n          }\n        }\n\n        .dropdown-menu {\n          transform: translateX(-133px);\n          border-radius: 8px;\n\n          &__title {\n            display: unset;\n            text-align: center;\n            font-weight: 400;\n            font-size: 16px;\n            line-height: 19px;\n            color: #999999;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  .header {\n    &__buttons {\n      gap: 8px;\n    }\n\n    &__button {\n      padding: 8px 10px;\n    }\n  }\n}\n\n@media only screen and (max-width: 374px) {\n  .header {\n    &__button {\n      flex-shrink: 0;\n      padding: 4px;\n    }\n  }\n}\n",".header {\n  display: flex;\n  width: 100%;\n  height: 84px;\n  z-index: 1;\n  background: var(--header-bg);\n}\n.header__container {\n  width: 100%;\n  height: 84px;\n  display: flex;\n  gap: 56px;\n  align-items: center;\n}\n.header__container-item:nth-child(1) {\n  width: 85px;\n}\n.header__container-item:nth-child(1) img {\n  width: 100%;\n}\n.header__container-item:nth-child(2) {\n  width: 60px;\n}\n.header__container-item:nth-child(2) a {\n  height: 100%;\n  display: block;\n  text-decoration: unset;\n}\n.header__container-item:nth-child(2) a span {\n  display: block;\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 42px;\n  color: #ff0009;\n}\n.header__container-item:nth-child(3) .user-container {\n  position: relative;\n  transform: translateY(0%);\n  transition-delay: 0s, 0s, 0.3s;\n  padding: 10px;\n  height: 48px;\n  background: #eaf6ff;\n  border-radius: 8px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.header__container-item:nth-child(3) .user-container svg {\n  width: 28px;\n  height: 28px;\n}\n.header__container-item:nth-child(3) .user-container span:nth-child(1) {\n  display: block;\n  width: 28px;\n  height: 28px;\n}\n.header__container-item:nth-child(3) .user-container span:nth-child(1) svg {\n  width: 28px;\n  height: 28px;\n}\n.header__container-item:nth-child(3) .user-container span:nth-child(2) {\n  font-family: \"Roboto\", serif;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 19px;\n  color: #999999;\n}\n.header__container-item:nth-child(3) .dropdown-menu {\n  display: none;\n  position: absolute;\n  background: #eaf6ff;\n  width: 181px;\n  min-height: 50px;\n  padding: 16px;\n  transform: translateY(-10px);\n  border: unset;\n}\n.header__container-item:nth-child(3) .dropdown-menu__title {\n  display: none;\n}\n.header__container-item:nth-child(3) .dropdown-menu__item {\n  padding-top: 10px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.header__container-item:nth-child(3) .dropdown-menu__button:nth-child(2) {\n  margin-top: 10px;\n}\n.header__container-item:nth-child(3) .dropdown-menu__button button {\n  width: 100%;\n  background: #ffffff;\n  color: red;\n  border-radius: 8px;\n  padding: 5px 10px;\n  border: 1px solid red;\n  white-space: nowrap;\n}\n.header__container-item:nth-child(3) .dropdown-menu__button .button-red {\n  background: red;\n  color: #ffffff;\n}\n.header__container-item:nth-child(3) .dropdown-active {\n  display: block;\n}\n.header__mobile-menu {\n  background: unset;\n  display: none;\n}\n.header__mobile-menu svg {\n  stroke: var(--text-color);\n}\n.header__logo {\n  width: 100px;\n  display: block;\n}\n.header__logo img {\n  width: 100%;\n}\n.header__list {\n  display: flex;\n  gap: 20px;\n}\n.header__list-item {\n  padding: 8px;\n  color: var(--text-color);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n}\n.header__list-item:hover {\n  color: var(--text-color);\n}\n.header__list-item--active {\n  border-bottom: 2px solid #ff0009;\n}\n.header__buttons {\n  display: flex;\n  gap: 34px;\n  margin-left: auto;\n}\n.header__button {\n  padding: 10px 28px;\n  text-align: center;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  border: 1px solid;\n  border-radius: 8px;\n  color: var(--text-color);\n}\n.header__button:hover {\n  color: var(--text-color);\n}\n.header__button--outline {\n  background: unset;\n  border-color: var(--text-color);\n}\n.header__button--primary {\n  background-color: #ff0009;\n  border-color: #ff0009;\n  color: #ffffff;\n}\n.header__button--primary:hover {\n  color: #ffffff;\n}\n\n@media only screen and (max-width: 1199px) {\n  .header__list {\n    display: none;\n  }\n  .header__mobile-menu {\n    display: block;\n  }\n  .header__container {\n    gap: 12px;\n  }\n}\n@media only screen and (max-width: 992px) {\n  .header .header-container-item:nth-child(1) {\n    width: auto;\n  }\n  .header .header-container-item:nth-child(2) {\n    width: 40px;\n  }\n  .header .header-container-item:nth-child(2) a span {\n    font-size: 24px;\n    line-height: 28px;\n  }\n  .header .header-container-item:nth-child(3) .user-container {\n    width: unset;\n  }\n  .header .header-container-item:nth-child(3) .user-container span:nth-child(2) {\n    display: none;\n  }\n  .header .header-container-item:nth-child(3) .dropdown-menu {\n    transform: translateX(-133px);\n    border-radius: 8px;\n  }\n  .header .header-container-item:nth-child(3) .dropdown-menu__title {\n    display: unset;\n    text-align: center;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 19px;\n    color: #999999;\n  }\n}\n@media only screen and (max-width: 575px) {\n  .header__buttons {\n    gap: 8px;\n  }\n  .header__button {\n    padding: 8px 10px;\n  }\n}\n@media only screen and (max-width: 374px) {\n  .header__button {\n    flex-shrink: 0;\n    padding: 4px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
